import { Typography } from "@suraasa/placebo-ui"
import { Theme, useMediaQuery } from "@suraasa/placebo-ui-legacy"
import clsx from "clsx"
import CpatLogo from "features/Cpat/assets/cpat-mini-logo.webp"
import React from "react"
import { useTheme } from "react-jss"

import styles from "./Navbar.module.css"

export type NavbarProps = {
  className?: string
  gutterBottom?: boolean
  slotEnd?: React.ReactNode
  navBarTitle?: string
}

const Navbar = ({
  navBarTitle,
  gutterBottom = true,
  className,
  slotEnd,
}: NavbarProps) => {
  const theme = useTheme<Theme>()

  const isSm = useMediaQuery(theme.breakpoints.down("sm"))

  const getTitle = () => {
    if (isSm) {
      return <img alt="" src={CpatLogo} width={40} height={40} />
    }
    if (
      navBarTitle &&
      navBarTitle.includes("Comprehensive Pedagogy Assessment of Teachers")
    ) {
      return (
        <div className="flex flex-row items-center">
          <img alt="" src={CpatLogo} className="me-1 size-5" />
          <Typography variant="title3">{navBarTitle}</Typography>
        </div>
      )
    }

    return <Typography variant="title3">{navBarTitle}</Typography>
  }

  return (
    <div
      className={clsx("fixed top-0 z-navbar w-full", {
        ["mb-4 md:mb-8"]: gutterBottom,
      })}
    >
      <nav
        className={clsx(
          "relative h-[62px] border-b border-b-onSurface-200 bg-onSurface-50",
          className,
          styles.root,
          "flex items-center py-1"
        )}
      >
        <div
          className={clsx(
            "flex w-full flex-wrap items-center justify-between p-2 sm:px-5 md:flex-nowrap",
            styles.container
          )}
        >
          <div className="flex grow items-center justify-start md:block md:grow-0">
            {getTitle()}
          </div>
          {slotEnd}
        </div>
      </nav>
    </div>
  )
}

export default React.memo(Navbar)
